import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import {
  success,
  error,
  loading,
  Updateloading,
} from "../common/helpers/toastify";
import Select from "react-select";
import { giftcardorder_head } from "../../components/common/Tablehead";
import { Pagination } from "../common/Pagination";
import CheckoutBlank from "../checkout/checkoutBlank";
// import { Customsubtable } from "./SubTablePos/Customsubtable";
import "../Posscreen/posscreen.scss";
import { _Api } from "../common/api/_call";
import { store } from "../../source/index";
import { useSelector } from "react-redux";
import CustomerSearchModal from "../common/module/customerSearch";
import TableColumnModal from "../../components/common/modules/tableColumn";
import { toFormatPrice, toUnformatPrice } from "../common/helpers/function";
import CheckoutSell from "../checkout/checkoutSell";
import CheckoutPayment from "../checkout/checkoutPayment";
import { useTranslation } from "react-i18next";
import { customOrder_status } from "../../components/common/helpers/status_class";
import ConfirmationModel from "../../admin/common/modules/confirmationmodel";
import DropdownFilter from "../Posscreen/DropdownFilter";
// import { by } from '@fullcalendar/core/internal-common';

const parseOrderDate = (value, dateFormat) => {
  if (!value) return null;
  const formats = ["DD/MM/YYYY", "MM/DD/YYYY", "YYYY/MM/DD", "YYYY-MM-DD", "DD-MM-YYYY"];
  const parsed = moment(value, dateFormat ? [dateFormat, ...formats] : formats, true);
  if (parsed.isValid()) return parsed.valueOf();
  const fallback = moment(value);
  return fallback.isValid() ? fallback.valueOf() : null;
};

const toNumber = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const num = Number(String(value).replace(/[^0-9.-]/g, ""));
  return Number.isNaN(num) ? null : num;
};

// Sort accessor per column index of giftcardorder_head.
const SORT_ACCESSORS = [
  null,
  null,
  (r, dateFormat) => parseOrderDate(r?.transaction_date, dateFormat),
  (r) => r?.order_no,
  null,
  (r) => toNumber(r?.amount),
];

const GiftCardOrderList = () => {
  const { t } = useTranslation();
  let navigate = useNavigate();
  let reduxdata = store.getState();
  let OrgSettings = reduxdata?.app?.posorganisation_settings;
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
  const [, setnewcolumndata] = useState(giftcardorder_head);
  const customer = useSelector((state) => state.app.customer);
  const saleperson = useSelector((state) => state.app.saleperson);
  const [, setfilterby] = useState("");
  const [orderlist, setOrderlist] = useState();
  const [orderTotal, setOrderTotal] = useState();
  const [, setdeletestatus] = useState(false);
  const [searchproductstatus, setsearchproductstatus] = useState(false);
  const parmissiondatashow = useSelector((state) => state.app.ApplyParmission);
  const [orderid, setOrderid] = useState("");
  const [showcheckout, setShowcheckout] = useState("blank");
  const [showpayment, setShowpayment] = useState(false);
  const [UpdatedCart, setUpdatedCart] = useState();
  const [TransactionDate, setTransactionDate] = useState(new Date());
  const [excuteTable, setexcuteTable] = useState(false);
  const [searchlist, setSearchlist] = useState();
  const [customerid, setCustomerid] = useState();
  const [statement, setStatement] = useState("");
  const [currentIdToChange, setCurrentIdToChange] = useState({});
  const [selecteditem, setSelecteditem] = useState([]);
  const [limit, setLimit] = useState(50);
  const [searchKey, setSearchKey] = useState();
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [sortConfig, setSortConfig] = useState({ index: null, direction: "asc" });

  const handleSort = (index) => {
    setSortConfig((prev) =>
      prev.index === index
        ? { index, direction: prev.direction === "asc" ? "desc" : "asc" }
        : { index, direction: "asc" }
    );
  };

  const dateFormat = OrgSettings?.date_picker?.toUpperCase();
  const sortedOrderlist = useMemo(() => {
    const list = Array.isArray(orderlist) ? orderlist : [];
    const accessor = SORT_ACCESSORS[sortConfig.index];
    if (!accessor) return list;
    const sorted = [...list].sort((a, b) => {
      const av = accessor(a, dateFormat);
      const bv = accessor(b, dateFormat);
      if (av === undefined || av === null || av === "") return 1;
      if (bv === undefined || bv === null || bv === "") return -1;
      if (typeof av === "number" && typeof bv === "number") return av - bv;
      return String(av).localeCompare(String(bv), undefined, { numeric: true });
    });
    return sortConfig.direction === "asc" ? sorted : sorted.reverse();
  }, [orderlist, sortConfig, dateFormat]);

  const [state, setstate] = useState({
    totalPages: 20,
    currentPage: 1,
  });

  const { totalPages, currentPage } = state;
  const handlePaginations = (current) => {
    setstate({ ...state, currentPage: current });
    Getcustomeorder(current);
  };

  const colorStyles = {
    option: (styles, { data }) => {
      return {
        ...styles,
        backgroundColor: data.color,
      };
    },
  };
  const selectOptions = [
    { label: 50, value: 50 },
    { label: 100, value: 100 },
    { label: 150, value: 150 },
  ];
  const changeStatus = (index, value, po_order_id, statusid) => {
    setStatement("Change Status");
    setCurrentIdToChange({ status: statusid, id: po_order_id });
    // setPo_sataus([{ index: index, status: value, po_order_id: po_order_id }]);
    document.querySelector("#status_query_select").click();
  };
  const clearItems = () => {
    setSelecteditem([]);
    setOrderlist((prevList) =>
      prevList.map((item) => ({ ...item, rowClass: "" }))
    );
  };
  const Getcustomeorder = async (current, firstlimit, search) => {
    setexcuteTable(false);
    let limit1 = firstlimit ? firstlimit : limit;
    try {
      const postdata = {
        searchKey: search ? search : searchKey,
        limit: firstlimit ? firstlimit : limit,
        skip: current ? (current - 1) * limit1 : 0,
        customer_id: customer?.id,
        order_type: "gift_card_order",
      };
      let res = await _Api(postdata, `api/v1/POS/customOrder/getOrderList`);
      if (res.code === 200) {
        setstate({
          ...state,
          totalPages: Math.ceil(res?.count / postdata?.limit),
          currentPage: current ? current : 1,
        });
        setexcuteTable(true);
        setOrderlist(res?.data);
        setOrderTotal(res?.summary);
      } else {
        setOrderlist([]);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const getlimit = (limit) => {
    setLimit(limit);
    Getcustomeorder(1, limit);
    setstate({ ...state, currentPage: 1 });
  };
  useEffect(() => {
    if (customer?.id) {
      Getcustomeorder();
    } else {
      error(t("Customer is required"));
    }
    // eslint-disable-next-line
  }, [customer?.id, TransactionDate]);

  //   const setSubTablecustom = async (order_id) => {
  //     var e = document.querySelector("#table-btn_" + order_id);
  //     var row = document.querySelector("#common-main-table-wrap-" + order_id);
  //     var classList_ = e.classList;
  //     if (classList_.contains("rotate-90")) {
  //       classList_.remove("rotate-90");
  //       let alllist_data = [...orderlist];
  //       alllist_data
  //         .filter((item) => item.order_id === order_id)
  //         .forEach((result) => {
  //           result.subTabledata = null;
  //         });
  //       setOrderlist(alllist_data);
  //     } else {
  //       classList_.add("rotate-90");
  //       let alllist_data = [...orderlist];
  //       const postdata = {
  //         Order_id: order_id,
  //       };
  //       let prioritydata = await _Api(
  //         postdata,
  //         `api/v1/POS/customOrder/getSkuByOrderList`
  //       );
  //       var html_ = Customsubtable(prioritydata, order_id, t);
  //       alllist_data
  //         .filter((item) => item.order_id === order_id)
  //         .forEach((result) => {
  //           result.subTabledata = html_;
  //         });
  //       setOrderlist(alllist_data);

  //       var checkRowSub = setInterval(function () {
  //         var rowSub = document.querySelector(
  //           "#common-sub-table-wrap-" + order_id
  //         );
  //         if (rowSub) {
  //           $(row).after(rowSub);
  //           clearInterval(checkRowSub);
  //         }
  //       }, 100);
  //     }
  //   };
  // const GetCartdetailorder = async () => {
  //   try {
  //     const postdata = {
  //       "order_id": orderid,
  //       'order_type': 'custom_order',
  //       "by_custom_order": true
  //     }
  //     let res = await _Api(postdata, `api/v1/POS/customOrder/getCartItems`)
  //     if (res.code === 200) {
  //       setUpdatedCart(res?.data);
  //       setShowcheckout('sell');
  //     } else {
  //       navigate('/app/pos/custom/customOrderDelivered')
  //     }
  //   } catch (err) {
  //     console.log(err, 'err')
  //   }
  // }
  // const GetCartdetailorder = async () => {
  //   if(orderid){
  //     navigate('/app/pos/posscreen',{state:{order_id: orderid, order_type: 'custom_order',by_custom_order: true}})
  //   }
  // }
  const GetCartdetailorder = async () => {
    if (selecteditem?.length) {
      navigate("/app/pos/posscreen", {
        state: {
          state1: {
            order_id: selecteditem,
            order_type: "custom_order",
            by_custom_order: true,
          },
        },
      });
    } else {
      error(t("No item selected!"));
    }
  };

  const getsearchlist = async (value) => {
    try {
      const posdata = {
        search: value,
        type: "inventory",
        from: "createYourOwn",
      };
      let res = await _Api(posdata, `api/v1/POS/customOrder/skuNameBySearch`);
      if (res.code === 200) {
        setSearchlist(res?.data);
      } else {
        setSearchlist([]);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const AddtoCart = async (product_id) => {
    if (!customer?.id) {
      error(t("Customer is Requried!!"));
      return;
    }
    if (!saleperson?.value) {
      error(t("SalePerson is Requried!!"));
      return;
    }
    const GetloadingID = loading();
    try {
      const postdata = {
        product_id: product_id,
        type: "inventory",
        customer_id: customer?.id,
        sales_person_id: saleperson?.value,
        order_type: "custom_order",
      };
      let res = await _Api(postdata, `api/v1/POS/customOrder/addItemToCart`);
      if (res.code === 200) {
        Updateloading(t, GetloadingID, t("Successfully Add to Cart!!"));
        setShowcheckout("sell");
        setsearchproductstatus(true);
      } else {
        Updateloading(t, GetloadingID, t("This Product Already in cart!!"), "error");
      }
    } catch (err) {
      console.log(err, "err");
      Updateloading(t, GetloadingID, t("Something went wrong"), "error");
    }
  };
  const getprintcustomorder = async () => {
    if (!customer?.id && !customerid) {
      error(t("Customer is Requried!!"));
      return;
    }
    let GetloadingID = loading();
    try {
      const postdata = {
        customer_id: customerid ? customerid : customer?.id,
      };
      let res = await _Api(
        postdata,
        `api/v1/POS/reports/print/customOrderOutstanding`
      );

      if (res.code === 200) {
        setTimeout(() => {
          const exportLinkElement = document.createElement("a");
          exportLinkElement.hidden = true;
          exportLinkElement.download = res?.name ? res?.name : "report.pdf";
          exportLinkElement.href = res?.link;
          exportLinkElement.text = "downloading...";
          exportLinkElement.setAttribute("target", "_blank");
          document.body.appendChild(exportLinkElement);
          exportLinkElement.click();
          exportLinkElement.remove();
          Updateloading(t, GetloadingID, t("download successfully"));
        }, 50);
      }
      if (res.code === 400) {
        Updateloading(t, GetloadingID, res?.messgae, t("error"));
      }
    } catch (err) {
      console.log(err, "err");
      Updateloading(t, GetloadingID, err, t("error"));
    }
  };
  // const selectedproduct = (event, id, ststus) => {
  //   if (event.target.checked) {
  //     if (ststus === 5) {
  //       setOrderid(id);
  //     } else {
  //       setOrderid("");
  //     }
  //   } else {
  //     setOrderid("");
  //   }
  // };
  const selectedproduct = (event, ordertype) => {
    let updatedSelected;

    if (event.target.checked) {
      // Base object
      let newItem = { id: event.target.value, order_type: ordertype };

      // Add property conditionally
      if (ordertype === "custom_order") {
        newItem.by_custom_order = true;
      } else if (ordertype === "repair_order") {
        newItem.by_repair_order = true;
      } else if (ordertype === "reserve") {
        newItem.reserve_sell = true;
      }

      updatedSelected = [...selecteditem, newItem];
    } else {
      updatedSelected = selecteditem.filter(
        (element) => element.id !== event.target.value
      );
    }

    setSelecteditem(updatedSelected);

    // Determine selected customer
    let selectedCustomer = null;
    if (updatedSelected.length > 0) {
      const firstSelectedId = updatedSelected[0].id;
      const firstSelectedRow = orderlist.find(
        (row) => row.order_id == firstSelectedId
      );
      selectedCustomer = firstSelectedRow?.customer_id || null;
    }

    // Shallow copy of orderlist
    let mainarray = [...orderlist];

    // Manipulate the copy in place
    mainarray.forEach((row, index) => {
      if (!selectedCustomer) {
        mainarray[index] = { ...row, rowClass: "" };
      } else if (row.customer_id !== selectedCustomer) {
        mainarray[index] = { ...row, rowClass: "row-inactive" };
      } else {
        mainarray[index] = { ...row, rowClass: "" };
      }
    });

    // Set updated orderlist
    setOrderlist(mainarray);
  };

  const filterbyname = (search) => {
    setstate({ ...state, currentPage: 1 });
    Getcustomeorder(currentPage, limit, search);
  };
  const handleChange = async () => {
    console.log("handle Change is here", currentIdToChange);
    try {
      let postdata = {
        status:
          currentIdToChange.status === 1 || currentIdToChange.status === 0
            ? 9
            : 1,
        id: currentIdToChange.id,
      };
      console.log(postdata, "Check post data");
      // http://localhost:3000/api/v1/pos/customOrder/edit-pos-status
      let res = await _Api(postdata, `api/v1/pos/customOrder/edit-pos-status`);
      if (res.code === 200) {
        success("Successfully updated!");
        console.log("checkout result");
        Getcustomeorder();
      }
    } catch (err) {
      console.log(err, "error");
    }
  };

  const handleClose = () => {
    console.log(currentIdToChange, "handle Close");
  };

  return (
    <>
      <div className="main-body custom-order-table">
        <div className="main-body-row">
          <div className="main-body-row-left-col p-0">
            <div className="com-data-area1">
              <div
                className="catalog-area-header-area-control-pos1"
                style={{ backgroundColor: "#FBFBFB" }}
              >
                <div className="catalog-area-header-area-control-pos1-left page-back-btn-inside">
                  <Link to="/app/pos/menu">
                    <img
                      className="page-back-btn-inside-img"
                      src={base_assets + "/images/icons/arrow-left.png"}
                      alt="back"
                    />
                  </Link>
                  <h1 className="heading">{t("Gift Card")}</h1>
                </div>

                <div className="catalog-area-header-area-control-pos1-right">
                  <div className="posorderlistdiv">
                    <img
                      className="com-search-bar-search-img"
                      onClick={() => filterbyname()}
                      src={base_assets + "images/admin/icons/gray-search.png"}
                      alt=""
                    />
                    <input
                      type="text"
                      value={searchKey}
                      placeholder="Search Order no."
                      onKeyPress={(e) =>
                        e.key === "Enter" && filterbyname(e.target.value)
                      }
                      onChange={(e) => {
                        setSearchKey(e.target.value);
                      }}
                    />
                    {searchKey ? (
                      <img
                        className="search-bar-clear"
                        onClick={(e) => {
                          setSearchKey("");
                          filterbyname("");
                        }}
                        src={base_assets + "images/icons/False.png"}
                        alt=""
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
              <div className="com-data-area1-header delivered-header">
                <Select
                  className="limit-select short"
                  options={selectOptions}
                  value={{ label: limit, value: limit }}
                  onChange={(e) => {
                    setLimit(e.value);
                    getlimit(e.value);
                  }}
                />
              </div>
              <div className="com-data-area1-inner">
                <div
                  className="main-body-main-table-wrap1 customOrderlist vertical-scroll-table1"
                  id="table-scroll"
                  style={{ maxHeight: "70vh", overflow: "auto" }}
                >
                  <table
                    id="com-data-area_table"
                    className="common-table first-row-gray w-100"
                  >
                    <thead>
                      <tr>
                        {giftcardorder_head.map((col, index) => {
                          const sortable =
                            Boolean(col?.sort) && Boolean(SORT_ACCESSORS[index]);
                          const active = sortConfig.index === index;
                          return (
                            <th
                              key={index}
                              className={col?.class}
                              onClick={sortable ? () => handleSort(index) : undefined}
                              style={{
                                position: "sticky",
                                top: 0,
                                zIndex: 2,
                                background: "#fff",
                                cursor: sortable ? "pointer" : undefined,
                              }}
                            >
                              {t(col?.lable)}
                              {sortable ? (
                                <div className="up-down-arrow-btn">
                                  <img
                                    className={
                                      "up-down-arrow-img up-down-arrow-img-forward" +
                                      (active && sortConfig.direction === "desc"
                                        ? ""
                                        : " active")
                                    }
                                    src={base_assets + "images/icons/up-down-arrow.png"}
                                    alt=""
                                  />
                                  <img
                                    className={
                                      "up-down-arrow-img up-down-arrow-img-reverse" +
                                      (active && sortConfig.direction === "desc"
                                        ? " active"
                                        : "")
                                    }
                                    src={
                                      base_assets +
                                      "images/icons/up-down-arrow-reverse.png"
                                    }
                                    alt=""
                                  />
                                </div>
                              ) : null}
                            </th>
                          );
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      <>
                        {sortedOrderlist.length
                          ? sortedOrderlist.map((result, key) => {
                              return (
                                <React.Fragment key={result?.order_id}>
                                  <tr
                                    id={`common-main-table-wrap-${result?.order_id}`}
                                    key={result?.order_id}
                                  >
                                    <td>
                                      <div className={"com-check"}>
                                        <input
                                          id={result?.order_id}
                                          type="checkbox"
                                          onChange={(e) =>
                                            selectedproduct(
                                              e,
                                              result?.order_type
                                            )
                                          }
                                          className="reserve_item pos_reservetablehead"
                                          data-id={result?.order_id}
                                          value={result?.order_id}
                                          name="customchack"
                                          checked={selecteditem.some(
                                            (item) =>
                                              item.id === result?.order_id
                                          )}
                                        />
                                        <label
                                          htmlFor={result?.order_id}
                                          className="com-check-label"
                                        ></label>
                                      </div>
                                    </td>
                                    <td>{key + 1}</td>
                                    <td>{result?.transaction_date}</td>
                                    <td className="link-color">
                                      <Link
                                        to="/app/pos/giftCard"
                                        state={{
                                          state1: { order_id: result?.order_id },
                                        }}
                                        style={{textDecoration:"none",color:"#5C74C7"}}
                                      >
                                        {result?.order_no}
                                      </Link>
                                    </td>
                                    <td>{result?.Qty}</td>
                                    <td>
                                      {toFormatPrice(result?.amount, {
                                        addSymbol: true,
                                      })}
                                    </td>
                                  </tr>
                                  {/* {excuteTable ? (
                                    <>
                                      {typeof result.subTabledata == "undefined"
                                        ? (result.subTabledata = "")
                                        : result.subTabledata}
                                    </>
                                  ) : null} */}
                                </React.Fragment>
                              );
                            })
                          : (
                            <tr>
                              <td colSpan={giftcardorder_head.length} className="text-center">
                                {t("No Data Available In Table")}
                              </td>
                            </tr>
                          )}
                      </>
                    </tbody>
                  </table>
                </div>
                {/* <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                  className="com-data-area1-footer"
                >
                  {orderlist?.length > 0 ? (
                    <div>
                      <span className="pagination-text">
                        {orderlist?.length > 0
                          ? (state.currentPage - 1) * limit + 1
                          : 0}{" "}
                        -{" "}
                        {orderlist?.length > 0
                          ? state.currentPage * limit > orderlist?.length
                            ? orderlist?.length
                            : state.currentPage * limit
                          : 0}{" "}
                        {t("of")} {orderTotal?.order_no_count} {t("Orders")}
                      </span>
                    </div>
                  ) : (
                    ""
                  )}

                  {orderlist?.length > 0 ? (
                    <Pagination
                      total={totalPages}
                      current={currentPage}
                      pagination={(crPage) => handlePaginations(crPage)}
                    />
                  ) : (
                    ""
                  )}
                </div> */}
                {/* {selecteditem?.length ? (
                  <div className="action-bar">
                    <div className="action-left">
                      <span className="action-count">
                        {selecteditem?.length} item
                        {selecteditem?.length > 1 ? "s" : ""} selected
                      </span>
                      <button
                        className="action-clear"
                        onClick={() => clearItems()}
                      >
                        ✕
                      </button>
                    </div>

                    <button
                      className="action-checkout"
                      onClick={() => {
                        GetCartdetailorder();
                      }}
                    >
                      {t("Check out")}
                    </button>
                  </div>
                ) : (
                  ""
                )} */}
              </div>
            </div>
          </div>
          <div className="main-body-row-right-col">
            {showcheckout === "sell" ? (
              <CheckoutSell
                setShowcheckout={setShowcheckout}
                setdeletestatus={setdeletestatus}
                setUpdatedCart={setUpdatedCart}
                UpdatedCart={UpdatedCart}
                setShowpayment={setShowpayment}
                showpayment={showpayment}
                ordertype={"pos_order"}
                setsearchproductstatus={setsearchproductstatus}
                searchproductstatus={searchproductstatus}
                by_custom_order={true}
                order_id={orderid ? orderid : ""}
              />
            ) : showcheckout === "payment" ? (
              <CheckoutPayment
                UpdatedCart={UpdatedCart}
                setShowcheckout={setShowcheckout}
                order_id={orderid ? orderid : ""}
                by_custom_order={true}
              />
            ) : (
              <CheckoutBlank />
            )}
          </div>
        </div>
      </div>
      <TableColumnModal
        tablehead={giftcardorder_head}
        tblName={"tbl_pos_customorderdelivered"}
        setnewcolumndata={setnewcolumndata}
        calldatatable={Getcustomeorder}
      ></TableColumnModal>
      <ConfirmationModel
        statement={statement}
        handler_submit={
          statement === "Change Status" ? handleChange : handleClose
        }
        handler_dismiss={handleClose}
      ></ConfirmationModel>
      <button
        className="d-none"
        data-bs-toggle="modal"
        data-bs-target="#createPurchaseModal"
        id="status_query_select"
      ></button>
    </>
  );
};

export default GiftCardOrderList;
